<template>
    <button
        class="relative rounded-full bg-base-doveGrey px-[.875rem] py-2 text-base-black sm:px-5 sm:py-3"
        @click="handler"
    >
        <SvgMinus24 class="!h-6 !w-6" />
        <SvgMinus24
            class="absolute left-1/2 top-1/2 !h-6 !w-6 -translate-x-1/2 -translate-y-1/2 duration-300 ease-gentle"
            :class="isContentOpen ? 'rotate-0' : '-rotate-90'"
        />
    </button>
</template>

<script setup lang="ts">
import SvgMinus24 from "@/components/svg/Minus24.vue";
const { isContentOpen, handler } = defineProps<{
    isContentOpen: boolean;
    handler: () => void;
}>();
</script>
